import axios from '../utils/ajax'
// 商品列表
export const queryCommodity = params => axios.get('/managementPlatform/admin/queryCommodity',{params})



// WEBPACK FOOTER //
// ./src/api/product.js